import styled from "@emotion/styled";
import { Box, Fab, lighten } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import theme from "../theme";

export const GoToTopContainer = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 10;
  height: 0;
  overflow: visible;
`;

export const GoToTopFabContainer = styled(Box)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const GoToTopFab = styled(Fab)`
  background-color: ${lighten(theme.palette.primary.light, 0.7)};
  box-shadow: ${({ theme }) => (theme as Theme).shadows[6]};
`;
